import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import ab from '../assets/images/hotel-booking-system.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const HotelBS = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${ab})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					HOTEL Booking SYSTEM
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					HOTEL Booking SYSTEM
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Hotel Booking Travel Website
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b.png' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Arya Aviation provides a platform by which a customer makes an
								online Hotel Booking unique. Our Hotel Booking System is
								directly connected to the APIs in which the data is fetched
								directly and the results are displayed in the form an Invoice.
								After selecting the hotel segment, it will redirect to the
								payment gateway for payment. And then the customer can generate
								the invoice. We are providing the Travel Portal Services in
								India, USA/UK Market and many more countries.
							</p>
							<br />
							<p>
								Hotel Booking System is a one stop solution which uses content
								from multiple suppliers that can meet the exact requirements of
								your Customers. Nowadays a wide range of accommodation choices
								is available at every location with different pricing and
								availability. So navigating through multiple suppliers can be a
								tedious task. To make it simple, Hotel API is integrated to get
								access to the global Hotel Content and best deals. With Hotel
								API Integration, your Customers get wider choice of hotels with
								realtime availability and Confirmation. Our Hotel booking is
								directly connected more than 7 Lac inventories in which the data
								is fetched and result is displayed. Through Hotel Booking
								System, you can browse the huge hotel inventories at one place,
								book Room, Cancel Room, generate bookings report, generate
								Cancellation report very easily.
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default HotelBS;
